import * as React from "react";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import Glyphicon from "../../../../Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "../../../../Shared/Glyphicon/EGlyphicon";

export function DreamsOverloadIcon({
    shouldDisplay,
}: {
    shouldDisplay: boolean;
}) {
    if (!shouldDisplay) {
        return null;
    }

    const styleClass = StyleClass(`dreamsOverloadIconBadge`, {
        borderRadius: "5px",
        color: "coral",
        fontSize: "13px",
        marginRight: "10px",
        textShadow: `0px 0px 10px coral`,
    });

    return (
        <span className={styleClass} data-tip={`reduce number of dreams`}>
            <Glyphicon icon={EGlyphicon["exclamation-sign"]} />
        </span>
    );
}
